/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnalysisInfoDto } from '../models/analysis-info-dto';
import { reportCenterAnalysis } from '../fn/report-center/report-center-analysis';
import { ReportCenterAnalysis$Params } from '../fn/report-center/report-center-analysis';
import { reportCenterGetGroups } from '../fn/report-center/report-center-get-groups';
import { ReportCenterGetGroups$Params } from '../fn/report-center/report-center-get-groups';
import { reportCenterGetMasterData } from '../fn/report-center/report-center-get-master-data';
import { ReportCenterGetMasterData$Params } from '../fn/report-center/report-center-get-master-data';
import { reportCenterLabresult } from '../fn/report-center/report-center-labresult';
import { ReportCenterLabresult$Params } from '../fn/report-center/report-center-labresult';
import { ReportCenterLabResultDto } from '../models/report-center-lab-result-dto';
import { reportCenterMarkReportReadImplicit } from '../fn/report-center/report-center-mark-report-read-implicit';
import { ReportCenterMarkReportReadImplicit$Params } from '../fn/report-center/report-center-mark-report-read-implicit';
import { ReportCenterMasterDataDto } from '../models/report-center-master-data-dto';
import { ReportCenterRecordResultDto } from '../models/report-center-record-result-dto';
import { reportCenterRecords } from '../fn/report-center/report-center-records';
import { ReportCenterRecords$Params } from '../fn/report-center/report-center-records';
import { reportCenterReportWithPdf } from '../fn/report-center/report-center-report-with-pdf';
import { ReportCenterReportWithPdf$Params } from '../fn/report-center/report-center-report-with-pdf';
import { ReportCenterSearchResultDto } from '../models/report-center-search-result-dto';
import { ReportWithPdfDto } from '../models/report-with-pdf-dto';

@Injectable({ providedIn: 'root' })
export class ReportCenterApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportCenterGetMasterData()` */
  static readonly ReportCenterGetMasterDataPath = '/api/reportcenter/mf';

  /**
   * Get report center master data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterGetMasterData()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterGetMasterData$Response(params?: ReportCenterGetMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCenterMasterDataDto>> {
    const obs = reportCenterGetMasterData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get report center master data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterGetMasterData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterGetMasterData(params?: ReportCenterGetMasterData$Params, context?: HttpContext): Observable<ReportCenterMasterDataDto> {
    const resp = this.reportCenterGetMasterData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCenterMasterDataDto>): ReportCenterMasterDataDto => r.body)
    );
  }

  /** Path part for operation `reportCenterGetGroups()` */
  static readonly ReportCenterGetGroupsPath = '/api/reportcenter/groups';

  /**
   * Get filtered report center groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterGetGroups()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCenterGetGroups$Response(params: ReportCenterGetGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCenterSearchResultDto>> {
    const obs = reportCenterGetGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get filtered report center groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterGetGroups$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCenterGetGroups(params: ReportCenterGetGroups$Params, context?: HttpContext): Observable<ReportCenterSearchResultDto> {
    const resp = this.reportCenterGetGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCenterSearchResultDto>): ReportCenterSearchResultDto => r.body)
    );
  }

  /** Path part for operation `reportCenterRecords()` */
  static readonly ReportCenterRecordsPath = '/api/reportcenter/records';

  /**
   * Get filtered report center records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterRecords()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCenterRecords$Response(params: ReportCenterRecords$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCenterRecordResultDto>> {
    const obs = reportCenterRecords(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get filtered report center records.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterRecords$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCenterRecords(params: ReportCenterRecords$Params, context?: HttpContext): Observable<ReportCenterRecordResultDto> {
    const resp = this.reportCenterRecords$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCenterRecordResultDto>): ReportCenterRecordResultDto => r.body)
    );
  }

  /** Path part for operation `reportCenterReportWithPdf()` */
  static readonly ReportCenterReportWithPdfPath = '/api/reportcenter/reports/{recID}';

  /**
   * Get report center record with PDF by recID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterReportWithPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterReportWithPdf$Response(params: ReportCenterReportWithPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportWithPdfDto>> {
    const obs = reportCenterReportWithPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get report center record with PDF by recID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterReportWithPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterReportWithPdf(params: ReportCenterReportWithPdf$Params, context?: HttpContext): Observable<ReportWithPdfDto> {
    const resp = this.reportCenterReportWithPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportWithPdfDto>): ReportWithPdfDto => r.body)
    );
  }

  /** Path part for operation `reportCenterMarkReportReadImplicit()` */
  static readonly ReportCenterMarkReportReadImplicitPath = '/api/reportcenter/reports/{recID}/mark-read-implicit';

  /**
   * Mark report center record read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterMarkReportReadImplicit()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterMarkReportReadImplicit$Response(params: ReportCenterMarkReportReadImplicit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportCenterMarkReportReadImplicit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Mark report center record read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterMarkReportReadImplicit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterMarkReportReadImplicit(params: ReportCenterMarkReportReadImplicit$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportCenterMarkReportReadImplicit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportCenterAnalysis()` */
  static readonly ReportCenterAnalysisPath = '/api/reportcenter/analyses/{lrsID}';

  /**
   * Get analysis by lrsID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterAnalysis()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterAnalysis$Response(params: ReportCenterAnalysis$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalysisInfoDto>> {
    const obs = reportCenterAnalysis(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get analysis by lrsID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterAnalysis$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterAnalysis(params: ReportCenterAnalysis$Params, context?: HttpContext): Observable<AnalysisInfoDto> {
    const resp = this.reportCenterAnalysis$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AnalysisInfoDto>): AnalysisInfoDto => r.body)
    );
  }

  /** Path part for operation `reportCenterLabresult()` */
  static readonly ReportCenterLabresultPath = '/api/reportcenter/labresults/{perID}/{casID}/{lrsID}';

  /**
   * Get labresults.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCenterLabresult()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterLabresult$Response(params: ReportCenterLabresult$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCenterLabResultDto>> {
    const obs = reportCenterLabresult(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get labresults.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCenterLabresult$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCenterLabresult(params: ReportCenterLabresult$Params, context?: HttpContext): Observable<ReportCenterLabResultDto> {
    const resp = this.reportCenterLabresult$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCenterLabResultDto>): ReportCenterLabResultDto => r.body)
    );
  }

}
